<script>
import axios from 'axios';
import moment from 'moment';
import Vue from 'vue';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import PermissionManager from '@/mixins/PermissionManager';
import FieldLabels from '@/mixins/FieldLabels';

Vue.use(Donut);

export default {
  mixins: [
    BreadcrumbsManager,
    PermissionManager,
    FieldLabels,
  ],
  components: {
    EsHeader,
    EsLoader,
  },
  data() {
    return {
      loading: false,
      nearMatches: {},
      locationAttributes: [],
      locationContact: [],
      locationGrades: [],
      locationFacilities: [],
      showModal: false,
      test: [],
      titles: [],
    };
  },
  created() {
    this.getMatches();
    this.getTitles();
    this.setBreadcrumb([
      { text: 'Home', to: { name: 'groupList' } },
      { text: 'Compare Near Match', to: { } },
    ]);
  },
  computed: {
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    openModal() {
      this.showModal = true;
    },
    async deleteMatch() {
      try {
        const res = await axios.put(`search/location/nearmatches/${this.nearMatches.requestId}`, { command: 'CANCEL' });
        this.$router.push(
          {
            name: 'nearMatches',
            params: { message: 'The location has been successfully removed.' },
          },
        );
      } catch {
        // handle
      }
    },
    async createMatch(idForAssign) {
      try {
        const res = await axios.put(`search/location/nearmatches/${this.nearMatches.requestId}`, { command: 'ASSIGN_ID', stateLocationIdForAssign: idForAssign });
        const { newLocationIdAssigned } = res.data;
        const { transStatus } = res.data;
        // LOCID_NEAR_MATCH_RESOLVE_BY_ASSIGN_ID
        this.$router.push({
          name: 'locationDetails',
          params: { id: newLocationIdAssigned, transStatus },
        });
      } catch {
        // handle
      }
    },
    async notMatch() {
      try {
        const res = await axios.put(`search/location/nearmatches/${this.nearMatches.requestId}`, { command: 'CREATE_NEW' });
        const idCreated = res.data.newLocationIdAssigned;
        const { transStatus } = res.data;
        // LOCID_NEAR_MATCH_RESOLVE_BY_CREATE_NEW
        this.$router.push({
          name: 'locationDetails',
          params: { id: idCreated, transStatus },
        });
      } catch {
        // handle error
      }
    },
    async getAttributes() {
      // locations
      for (let i = 0; i < this.nearMatches.response.locationPotentialMatches.length; i += 1) {
        try {
          const res = await axios.get(`locations/${this.nearMatches.response.locationPotentialMatches[i].id}/attributes`);
          this.locationAttributes.push(res.data);
        } catch {
          // handle
        }
      }
    },
    async getContact() {
      // locations
      for (let i = 0; i < this.nearMatches.response.locationPotentialMatches.length; i += 1) {
        try {
          const res = await axios.get(`locations/${this.nearMatches.response.locationPotentialMatches[i].id}`);
          this.locationContact.push(res.data);
        } catch {
          // handle
        }
      }
    },
    async getGrades() {
      // locations
      for (let i = 0; i < this.nearMatches.response.locationPotentialMatches.length; i += 1) {
        try {
          const res = await axios.get(`locations/${this.nearMatches.response.locationPotentialMatches[i].id}/grades`);
          this.locationGrades.push(res.data);
        } catch {
          // handle
        }
      }
    },
    async getFacilities() {
      // locations
      for (let i = 0; i < this.nearMatches.response.locationPotentialMatches.length; i += 1) {
        try {
          const res = await axios.get(`locations/${this.nearMatches.response.locationPotentialMatches[i].id}/facilities`);
          this.locationFacilities.push(res.data);
        } catch {
          // handle
        }
      }
    },
    compareAddress(master, nearMatch) {
      let masterAddress = master.street1 + master.street2 + master.city + master.stateCode + master.zip;
      let nearMatchAddress = nearMatch.street1 + nearMatch.street2 + nearMatch.city + nearMatch.stateCode + nearMatch.zip;
      if (masterAddress !== nearMatchAddress) {
        return true;
      }
      return false;
    },
    compareDate(locationDate, masterDate) {
      let location = moment(locationDate).format('MM/DD/YYYY'); ;
      let master = moment(masterDate).format('MM/DD/YYYY');
      if (location !== master) {
        return true;
      }
      return false;
    },
    compareFields(master, nearMatch) {
      if (master !== nearMatch) {
        return true;
      }
      return false;
    },
    mapTitle(title) {
      if (this.titles && title) {
        const description = this.titles.find(x => x.code === title)
        return description.description;
      }
      return 'N/A';
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    async getMatches() {
      try {
        this.toggleLoading();
        const res = await axios.get(`search/location/nearmatches/${this.$route.params.nearMatchId}/details`);
        this.nearMatches = res.data;
        this.getAttributes();
        this.getContact();
        this.getGrades();
        this.getFacilities();
        this.toggleLoading();
      } catch {
        // handle error
      }
    },
    async getTitles() {
      try {
        const res = await axios.get('titles?active=true');
        this.titles = res.data;
      } catch {
        // handle error
      }
    }
  },
};
</script>

<template>
  <div class="document-container">
    <div v-if="showModal" class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title has-text-weight-bold">
            Cancel Submission Record
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="closeModal">
          </button>
        </header>
        <section class="modal-card-body">
          <div class="modal-body">
            Are you sure you want to cancel this submission record?
          </div>
          <div class="is-flex flex-justify--end flex-align--center">
            <a @click="closeModal">Cancel</a>
            <button
              class="button is-primary margin-left"
              @click="deleteMatch()">
                Cancel Submission Record
            </button>
          </div>
        </section>
      </div>
    </div>
    <div class="document">
      <div class="header">
        <es-header>
          <template #header>
            <div class="header-title">
              Compare Records
            </div>
            <div class="header-subtitle">
              The Near Matches for the submission record are displayed below.
            </div>
          </template>
          <template #actions>
              <ul>
                <li class="p-narrow no-border">
                  <div class="list-content">
                    <div class="field is-grouped">
                      <div
                        v-if="hasModule('LOCID:MATCH:RESOLVENM:CANCEL')"
                        class="control is-flex flex-align--center"
                      >
                        <a @click="openModal()">Cancel Submission Record</a>
                      </div>
                      <div class="control" v-if="hasModule('LOCID:MATCH:RESOLVENM:NOMATCH:CREATEID')">
                        <button
                          class="button is-link is-light"
                          @click="notMatch()"
                        >
                          No Match: Create a New State ID
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
          </template>
        </es-header>
      </div>
      <div class="padding--1rem">
        <div v-if="loading">
          <es-loader/>
        </div>
        <div v-else class="">
          <div class="outer">
            <div class="inner">
              <table class="table">
                <tbody>
                  <tr>
                    <td class="compare-panel vertical-align--initial">
                      <div class="text-align--center">
                        SUBMISSION RECORD :
                      </div>
                    </td>
                    <td
                      v-for="(potentialMatch, index) in nearMatches.response.locationPotentialMatches"
                      :key="index"
                      class="compare-panel border--left"
                    >
                      <div class="is-flex flex-direction--column flex-align--center">
                        <div class="is-size-7">
                          NEAR MATCH {{ index+1 }} :
                        </div>
                        <div class="has-text-weight-bold is-size-5 margin-bottom--half">
                          ID {{ potentialMatch.id }}
                        </div>
                        <div class="">
                          <vc-donut
                            class="margin-bottom--half"
                            :size="60"
                            :sections="[{ value: potentialMatch.percent, color: '#474282' },
                            { value: 100 - potentialMatch.percent, color: '#C8C8C8'}]">
                            <h1 class="percent-label">{{ potentialMatch.percent }}%</h1>
                          </vc-donut>
                          <div class="has-text-grey margin-bottom--half">
                            Match Score
                          </div>
                        </div>
                        <button
                          v-if="hasModule('LOCID:MATCH:RESOLVENM:MATCHDEC')"
                          class="button is-primary"
                          @click="createMatch(potentialMatch.id)"
                        >
                          Match: Assign ID {{ potentialMatch.id }}
                        </button>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="compare-panel compare-panel--heading has-text-weight-bold is-size-7">
                      Matching Fields
                    </td>
                    <td
                      v-for="(potentialMatch, index) in nearMatches.response.locationPotentialMatches"
                      :key="index"
                      class="compare-panel compare-panel--heading has-text-weight-bold is-size-7"
                    >
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--cell">
                      <div class="">
                        <div class="submission-header has-text-left">
                          Location Name
                        </div>
                        <div class="compare--content">
                          {{ nearMatches.request.location.name }}
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="(potentialMatch, index) in nearMatches.response.locationPotentialMatches"
                      :key="index"
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                      :class="{ 'panel--highlighted': compareFields(nearMatches.request.location.name, potentialMatch.matchedObject.name) }"
                    >
                      <div class="compare--content">
                        {{ potentialMatch.matchedObject.name }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--cell">
                      <div class="">
                        <div class="submission-header has-text-left">
                          Address
                        </div>
                        <div class="compare--content">
                          <div class="">
                            {{ nearMatches.request.location.street1 }}
                            {{ nearMatches.request.location.street2 }}
                          </div>
                          <div class="">
                            {{ nearMatches.request.location.city }},
                            {{ nearMatches.request.location.stateCode }}
                            {{ nearMatches.request.location.zip }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="(potentialMatch, index) in nearMatches.response.locationPotentialMatches"
                      :key="index"
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                      :class="{ 'panel--highlighted': compareAddress(nearMatches.request.location, potentialMatch.matchedObject) }"
                    >
                      <div class="compare--content">
                        <div class="">
                          {{ potentialMatch.matchedObject.street1 }}
                          {{ potentialMatch.matchedObject.street2 }}
                        </div>
                        <div class="">
                          {{ potentialMatch.matchedObject.city }},
                          {{ potentialMatch.matchedObject.stateCode }}
                          {{ potentialMatch.matchedObject.zip }}
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="compare-panel compare-panel--heading has-text-weight-bold is-size-7">
                      Contact Information
                    </td>
                    <td
                      v-for="(potentialMatch, index) in nearMatches.response.locationPotentialMatches"
                      :key="index"
                      class="compare-panel compare-panel--heading has-text-weight-bold is-size-7"
                    >
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--cell">
                      <div class="">
                        <div class="submission-header has-text-left">
                          Contact Name
                        </div>
                        <div v-if="!nearMatches.request.location.adminFirstName && !nearMatches.request.location.adminLastName" class="compare--content">
                          N/A
                        </div>
                        <div v-else class="compare--content">
                          {{ nearMatches.request.location.adminFirstName + ' ' + nearMatches.request.location.adminLastName }}
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="(contact, index) in locationContact"
                      :key="index"
                      v-if="contact.adminFirstName || contact.adminLastName"
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                      :class="{ 'panel--highlighted': compareFields(nearMatches.request.location.adminFirstName, contact.adminFirstName) ||
                                                      compareFields(nearMatches.request.location.adminLastName, contact.adminLastName)} ||
                                                      compareFields(nearMatches.request.location.adminTitle, mapTitle(contact.adminTitle)) ||
                                                      compareFields(nearMatches.request.location.adminEmail, contact.adminEmail) ||
                                                      compareFields(nearMatches.request.location.adminPhone, contact.adminPhone)"
                    >
                      <div class="compare--content">
                        {{ contact.adminFirstName + ' ' + contact.adminLastName}}
                      </div>
                    </td>
                    <td
                      v-else
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom">
                      <div class="compare--content">
                        N/A
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--cell">
                      <div class="">
                        <div class="submission-header has-text-left">
                          Contact Role
                        </div>
                        <div class="compare--content">
                          {{ nearMatches.request.location.adminTitle }}
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="(contact, index) in locationContact"
                      :key="index"
                      v-if="contact.adminTitle"
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                      :class="{ 'panel--highlighted': compareFields(nearMatches.request.location.adminTitle, mapTitle(contact.adminTitle)) }"
                    >
                      <div class="compare--content">
                        {{ mapTitle(contact.adminTitle) }}
                      </div>
                    </td>
                    <td
                      v-else
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                    >
                      <div class="compare--content">
                        N/A
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--cell">
                      <div class="">
                        <div class="submission-header has-text-left">
                          Contact Email
                        </div>
                        <div class="compare--content">
                          {{ nearMatches.request.location.adminEmail }}
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="(contact, index) in locationContact"
                      :key="index"
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                      :class="{ 'panel--highlighted': compareFields(nearMatches.request.location.adminEmail, contact.adminEmail) }"
                    >
                      <div v-if="!contact.adminEmail" class="compare--content">
                        N/A
                      </div>
                      <span v-else class="compare--content">
                        {{ contact.adminEmail }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--cell">
                      <div class="">
                        <div class="submission-header has-text-left">
                          Contact Phone
                        </div>
                        <div v-if="!nearMatches.request.location.adminPhone" class="compare--content">
                          N/A
                        </div>
                        <div v-else class="compare--content">
                          {{ nearMatches.request.location.adminPhone }}
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="(contact, index) in locationContact"
                      :key="index"
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                      :class="{ 'panel--highlighted': compareFields(nearMatches.request.location.adminPhone, contact.adminPhone) }"
                    >
                      <div v-if="!contact.adminPhone" class="compare--content">
                        N/A
                      </div>
                      <div v-else class="compare--content">
                        {{ contact.adminPhone }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--heading has-text-weight-bold is-size-7">
                      Location Information
                    </td>
                      <td
                        v-for="(object, index) in locationContact"
                        :key="index"
                        class="compare-panel compare-panel--heading has-text-weight-bold is-size-7" style="text-align:center"
                      >
                      </td>
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--cell">
                      <div class="">
                        <div class="submission-header has-text-left">
                          Start Date
                        </div>
                        <div v-if="this.nearMatches.request.location.startDate" class="compare--content">
                          {{ nearMatches.request.location.startDate | formatDateMMDDYYYY }}
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="(object, index) in locationContact"
                      :key="index"
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                      :class="{ 'panel--highlighted': compareDate(nearMatches.request.location.startDate, object.startDate) }"
                    >
                      <div class="compare--content">
                        {{ object.startDate | formatDateMMDDYYYY }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--cell">
                      <div class="">
                        <div class="submission-header has-text-left">
                          End Date
                        </div>
                        <div v-if="!nearMatches.request.location.endDate" class="compare--content">
                          N/A
                        </div>
                        <div v-else class="compare--content">
                          {{ nearMatches.request.location.endDate | formatDateMMDDYYYY }}
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="(object, index) in locationContact"
                      :key="index"
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                      :class="{ 'panel--highlighted': compareDate(nearMatches.request.location.endDate, object.endDate) }"
                    >
                      <div class="compare--content">
                        {{ object.endDate | formatDateMMDDYYYY }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--heading has-text-weight-bold is-size-7">
                      Grade Information
                    </td>
                    <td
                      v-for="(grade, index) in locationGrades"
                      :key="index"
                      class="compare-panel compare-panel--heading has-text-weight-bold is-size-7" style="text-align:center"
                    >
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--cell">
                      <div class="">
                        <div class="submission-header has-text-left">
                          Grade(s)
                        </div>
                        <div v-if="!nearMatches.request.location.grade" class="compare--content">
                          N/A
                        </div>
                        <div v-else class="compare--content">
                          {{ nearMatches.request.location.grade }}
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="(grade, index) in locationGrades"
                      :key="index"
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                    >
                      <div v-if="grade.length === 0" class="compare--content">
                        N/A
                      </div>
                      <span
                        v-else
                        v-for="(o, index) in grade"
                        :key="index"
                        class="compare--content comma"
                      >
                        {{ o.grade.code }}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td class="compare-panel compare-panel--heading has-text-weight-bold is-size-7">
                      Facility Information
                    </td>
                    <td
                    v-for="(facility, index) in locationFacilities"
                    :key="index"
                      class="compare-panel compare-panel--heading has-text-weight-bold is-size-7" style="text-align:center"
                    >
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--cell">
                      <div class="">
                        <div class="submission-header has-text-left">
                          Facility Type(s)
                        </div>
                        <div class="compare--content">
                          --
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="(facility, index) in locationFacilities"
                      :key="index"
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                    >
                      <div v-if="facility.length === 0" class="compare--content">
                        N/A
                      </div>
                      <span
                        v-else
                        v-for="(o, index) in facility"
                        :key="index"
                        class="compare--content comma"
                      >
                        {{ o.facility.description }}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td class="compare-panel compare-panel--heading has-text-weight-bold is-size-7">
                      Attribute Information
                    </td>
                    <td
                    v-for="(attribute, index) in locationAttributes"
                    :key="index"
                      class="compare-panel compare-panel--heading has-text-weight-bold is-size-7" style="text-align:center"
                    >
                    </td>
                  </tr>
                  <tr>
                    <td class="compare-panel compare-panel--cell">
                      <div class="">
                        <div class="submission-header has-text-left">
                          Attribute(s)
                        </div>
                        <div class="compare--content">
                          --
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="(attribute, index) in locationAttributes"
                      :key="index"
                      class="compare-panel compare-panel--cell border--left vertical-align--bottom"
                    >
                      <div v-if="attribute.length === 0" class="compare--content">
                        N/A
                      </div>
                      <span
                        v-for="(o, index) in attribute"
                        :key="index"
                        class="compare--content comma"
                      >
                        {{ o.attribute.description }}
                      </span>
                    </td>
                  </tr>

                  <tr v-if="hasModule('LOCID:MATCH:RESOLVENM:MATCHDEC')">
                    <td class="compare--content">
                      &nbsp;
                    </td>
                    <td
                      v-for="(potentialMatch, index) in nearMatches.response.locationPotentialMatches"
                      :key="index"
                      class="compare-panel border--left text-align--center"
                    >
                      <button
                        class="button is-primary"
                        @click="createMatch(potentialMatch.id)"
                      >
                        Match: Assign ID {{ potentialMatch.id }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="field is-grouped is-flex flex-justify--end">
          <div
            v-if="hasModule('LOCID:MATCH:RESOLVENM:CANCEL')"
            class="control is-flex flex-align--center"
          >
            <a @click="openModal()">Cancel Submission Record</a>
          </div>
          <div class="control" v-if="hasModule('LOCID:MATCH:RESOLVENM:NOMATCH:CREATEID')">
            <button
              class="button is-link is-light"
              @click="notMatch()"
            >
              No Match: Create a New ID
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  .comma + .comma:before
    content: ",  "
  .panel--highlighted
    background-color: rgb(255, 245, 214)
  .border--left
    border-left: 1px solid #ccc
  .border--bottom
    border-bottom: 1px solid #ccc
  .padding--1rem
    padding: 1rem
  .margin-bottom
    margin-bottom: 1rem
  .margin-left
    margin-left: 1rem
  .margin-bottom--half
    margin-bottom: 0.5rem
  .submission-header
    font-size: 12px
    color: #7A7A7A
  .compare-panel
    padding: 1rem
    min-width: 320px
    max-width: 320px
    // flex-wrap: wrap
  .compare-panel--cell
    padding: 0.5rem
    // border: 1px solid grey
  .compare-panel--heading
    background-color: #ccc
    // margin: 0 1rem
    padding: 0.5rem
  .compare--content
    font-size: 16px
    font-weight: bold
    text-align: left
  .compare-panel--summary
    flex: 1 0 auto

  .thing
    min-width: 300px
    max-width: 350px

  .test
    // flex-wrap: wrap
    overflow: hidden
    white-space: nowrap

  .percent-label
    font-style: bold
    color: black
    font-size: 1.1rem
    font-weight: 800
    padding: .25rem 0 .25rem .15rem

  table
    // table-layout: fixed
    width: 100%
    // margin-left: -100px

  th
    vertical-align: top
    border-top: 1px solid #ccc

  td
    min-width: 320px
    max-width: 320px

  .outer
    position: relative
    margin-left: auto
  .inner
    overflow-x: auto
    overflow-y: visible
    // margin-left: 320px
    max-width: max-content
  .modal-card-title
    display: flex
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start


  .text-align--center
    text-align: center
  .vertical-align--initial
    vertical-align: initial
  .vertical-align--bottom
    vertical-align: bottom
</style>
